import { DatePicker, Form, FormInstance, FormItemProps } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';

const { RangePicker: RangePickerAnt } = DatePicker;

interface SelectUserProps {
  form: FormInstance;
  formItemProps?: FormItemProps;
}

// eslint-disable-next-line import/prefer-default-export
export function RangePicker({ form, formItemProps: { label = 'Date', ...formItemProps } = {} }: SelectUserProps) {
  const handleRangeChange: RangePickerProps['onChange'] = (dates) => {
    if (!dates) return;

    const [start, end] = dates;

    if (start && end) {
      const adjustedDates = [start.startOf('day'), end.endOf('day')];

      form.setFieldsValue({ updatedAt: adjustedDates });
    }
  };

  return (
    <Form.Item name="updatedAt" label={label} {...formItemProps}>
      <RangePickerAnt placeholder={['Date Start', 'Date End']} onChange={handleRangeChange} style={{ width: '100%' }} />
    </Form.Item>
  );
}
